<template>
  <div class="flex flex-wrap justify-center" v-if="props.list?.length > 0">
    <NuxtLinkLocale
      :locale="switchBlogLocale()"
      v-for="(item, key) in props.list"
      :to="`/${cardType}/${item.slug}`"
      :key="key"
      :class="{ 'lg:mx-8': halfColumn !== false && key >= halfColumn }"
      class="topic-card group mx-auto flex flex-row flex-nowrap justify-between gap-4"
    >
      <div class="flex justify-center relative overflow-hidden cursor-pointer w-[60px] items-center h-full">
        <NuxtImg
          v-if="item.icon?.permalink"
          loading="lazy"
          :src="item.icon.permalink"
          :alt="item.icon?.alt"
          class="group-hover:invert group-hover:sepia-0 group-hover:saturate-[0.8] group-hover:hue-rotate-[121deg] group-hover:brightness-[1.02] group-hover:contrast-[1.25]"
          width="60"
          height="37"
        />
      </div>
      <div class="md:ml-0 text-left topic-text">
        <div class="text-blog-18 text-secondary group-hover:text-white font-bold mb-2 max-h-full">
          {{ item.title }}
        </div>
        <p class="text-sm leading-relaxed group-hover:text-white max-h-full">
          {{ cardType === "faqs" ? item.short_description : item.summary_text }}
        </p>
      </div>
    </NuxtLinkLocale>
  </div>
</template>
<script setup lang="ts">
const route = useRoute();
const props = defineProps({
  card_type: {
    type: String,
    default: "faqs",
  },
  list: Array<{
    id: string;
    title: string;
    slug: string;
    icon: {
      alt?: string;
      title?: string;
      caption?: string;
      attribution?: string;
      url: string;
      permalink: string;
    };
    short_description: string;
  }>,
  default: [],
});
const cardType = ref("");
cardType.value = props.card_type;

const topicColumn = ref(3);
const halfColumn = ref(false);
const listLength = props.list?.length ?? 0;
if (listLength % topicColumn.value) {
  let fullRow = Math.floor(listLength / topicColumn.value);
  halfColumn.value = fullRow * topicColumn.value;
}
</script>

<style scoped>
.topic-text {
  width: calc(100% - (60px + 30px));
}
</style>
